import React from 'react'
import PointedBar from '../componentes/pointedBar/pointedBar'

const Test = (props) => {
    const handleChange = (value) => {
        console.log(value)
    }
    return (
        <section>
            <br />
            <PointedBar
                initial={1.75}
                handleChange={handleChange}
            />
        </section>
    )
}

export default Test 